import React, { useState } from "react";
import {
  List,
  Input,
  Button,
  Form,
  Popconfirm,
  message,
  Card,
  Row,
  Col,
  Switch,
  Typography,
  Tag,
  Select,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
  CloseOutlined,
} from "@ant-design/icons";

import { editStock } from "../../utils/fetchProducts";
import DefontanaStockTag from "./DefontanaStockTag";

const { Text } = Typography;

const tagRender = (props) => {
  const { label, value, closable, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={"red"}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginInlineEnd: 4 }}
    >
      {label}
    </Tag>
  );
};

const VariantsProducts = ({
  variants,
  setVariants,
  loadingState,
  requestVariants,
  addVariantCallback,
  editVariantCallback,
  deleteVariantCallback,
}) => {
  const { loadingVariants, setLoadingVariants } = loadingState;

  const [isEditing, setIsEditing] = useState(null);
  const [inputValues, setInputValues] = useState({ variant: "", tivendo_id: "" });

  const [showAddVariantForm, setShowAddVariantForm] = useState(false);

  const [form] = Form.useForm();

  const handleEdit = (item) => {
    setIsEditing(item);
    setInputValues({ variant: item.variant, tivendo_id: item.tivendo_id || "" });
  };

  const handleSave = async () => {
    setLoadingVariants(true);
    await editVariantCallback(isEditing.id, {
      variant: inputValues.variant,
      tivendo_id: inputValues.tivendo_id,
    });
    setIsEditing(null);
  };

  const handleDelete = async (item) => {
    console.log("Delete", item);
    setLoadingVariants(true);
    await deleteVariantCallback(item); // wait till this resolves
  };

  const handleCancel = () => {
    setIsEditing(null);
  };

  const stockOptions = [
    { value: true, label: "Hay Stock" },
    { value: false, label: "Sin Stock" },
  ];

  const handleEditStock = async (variantID, stockValue) => {
    setLoadingVariants(true);
    try {
      const response = await editStock(variantID, stockValue);
      requestVariants();
      message.success("Stock modificado correctamente!");
      // setLoadingVariants(false);
    } catch (err) {
      console.error("Error al editar stock:", err);
      message.error("Error al editar stock. Recargue la página.");
      setLoadingVariants(false);
    }
  };

  const addVariant = async (vals) => {
    setLoadingVariants(true);
    const formData = {
      ...vals,
      stock: vals.stock ? vals.stock : false,
      tivendo_id: vals.tivendo_id ? vals.tivendo_id : undefined,
    };
    await addVariantCallback(formData); // wait till this resolves
    setShowAddVariantForm(false);
  };

  return (
    <div className="w-full">
      {variants.map((variant, index) => {
        const editingThisVariant = isEditing && isEditing.id === variant.id;
        return (
          <Card key={index} style={{ marginBottom: 16 }} className="">
            <Row align="middle" className="">
              <Col span={7} className="flex-wrap">
                {editingThisVariant ? (
                  <Input
                    value={inputValues.variant}
                    placeholder="Nombre variante"
                    disabled={loadingVariants}
                    onChange={(e) =>
                      setInputValues({ ...inputValues, variant: e.target.value })
                    }
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handleSave();
                      }
                    }}
                  />
                ) : (
                  <Text strong className={loadingVariants ? "text-gray-400" : ""}>
                    {variant.variant}
                  </Text>
                )}
              </Col>
              <Col span={6} className="pr-2">
                {editingThisVariant ? (
                  <Input
                    value={inputValues.tivendo_id}
                    placeholder="SKU (Tivendo ID)"
                    disabled={loadingVariants}
                    onChange={(e) =>
                      setInputValues({
                        ...inputValues,
                        tivendo_id: e.target.value,
                      })
                    }
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handleSave();
                      }
                    }}
                  />
                ) : (
                  <Tag color="blue">
                    SKU (Tivendo ID): {variant.tivendo_id || "—"}
                  </Tag>
                )}
              </Col>
              <Col span={4} className="flex flex-col space-y-1 items-start">
                {variant.stock ? (
                  <Tag color="green">Stock</Tag>
                ) : (
                  <Tag color="red">Sin Stock</Tag>
                )}
                <DefontanaStockTag
                  variantId={variant.id}
                  tivendoId={variant.tivendo_id}
                />
              </Col>
              <Col
                span={7}
                align="left"
                className="flex space-x-2 flex-row-reverse"
              >
                {editingThisVariant ? (
                  <>
                    <Button
                      type="link"
                      icon={<CloseOutlined />}
                      onClick={handleCancel}
                      disabled={loadingVariants}
                    />
                    <Button
                      type="link"
                      icon={<SaveOutlined />}
                      onClick={handleSave}
                      disabled={loadingVariants}
                    />
                  </>
                ) : (
                  <>
                    <Popconfirm
                      title="Atención! Esta acción no se puede deshacer."
                      onConfirm={() => handleDelete(variant)}
                      okText="Eliminar"
                      okButtonProps={{
                        style: { backgroundColor: "red", borderColor: "red" },
                      }} // Custom red background color
                    >
                      <Button
                        type="link"
                        icon={<DeleteOutlined />}
                        disabled={loadingVariants}
                      />
                    </Popconfirm>
                    <Button
                      type="link"
                      icon={<EditOutlined />}
                      onClick={() => handleEdit(variant)}
                      disabled={loadingVariants}
                    />
                    <Switch
                      defaultChecked={variant.stock}
                      onChange={(value) => {
                        handleEditStock(variant.id, value);
                      }}
                      disabled={loadingVariants}
                    />
                  </>
                )}
              </Col>
            </Row>
          </Card>
        );
      })}
      {showAddVariantForm ? (
        <Form
          disabled={loadingVariants}
          onFinish={(vals) => {
            addVariant(vals);
          }}
        >
          <Card style={{ marginBottom: 16 }} className="items-center">
            <Row align="middle" className="">
              <Col span={7} className="">
                <Form.Item
                  className="m-0"
                  name="variant"
                  rules={[
                    {
                      required: true,
                      message: "Debes ingresar un nombre para la variante.",
                    },
                  ]}
                >
                  <Input placeholder="Nombre variante" />
                </Form.Item>
              </Col>
              <Col span={7} className="pr-2">
                <Form.Item className="m-0" name="tivendo_id">
                  <Input placeholder="SKU (Tivendo ID)" />
                </Form.Item>
              </Col>
              <Col
                span={8}
                align="left"
                className="flex space-x-2 items-center"
              >
                <div className="">Stock:</div>
                <Form.Item name="stock" className="m-0">
                  <Switch defaultValue={false} />
                </Form.Item>
              </Col>
              <Col span={2} style={{ textAlign: "right" }}>
                <Form.Item className="m-0">
                  <Button
                    htmlType="submit"
                    type="link"
                    icon={<SaveOutlined />}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Button onClick={() => setShowAddVariantForm(false)}>Cancelar</Button>
        </Form>
      ) : (
        <Button
          type="dashed"
          onClick={() => {
            setShowAddVariantForm(true);
            // message.warning("Esta funcionalidad aún no está disponible.");
          }}
          icon={<PlusOutlined />}
          style={{ width: "100%", marginTop: 6, height: "50px" }}
          disabled={loadingVariants}
        >
          Añadir Variante
        </Button>
      )}
    </div>
  );
};

export default VariantsProducts;
